export default [
  {
    meta: {
      is_auth: true,
      is_admin: true,
      title: "appointments",
      layout: "dashboard",
    },
    path: "/appointments",
    name: "appointments",
    component: () => import("@/layouts/index/AppointmentIndex.vue"),
    children: [
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Liste d'articles",
          layout: "dashboard",
        },
        path: "index",
        name: "appointments-index",
        component: () => import("@/views/appointments/Listing.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Creer un produit",
          layout: "dashboard",
        },
        path: "create",
        name: "appointments-create",
        component: () => import("@/views/appointments/Create.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Modifier un produit",
          layout: "dashboard",
        },
        path: ":reference/edit",
        name: "appointments-edit",
        component: () => import("@/views/appointments/Edit.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Modifier un produit",
          layout: "dashboard",
        },
        path: ":reference/details",
        name: "appointments-details",
        component: () => import("@/views/appointments/Details.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Modifier un produit",
          layout: "dashboard",
        },
        path: ":reference/validate",
        name: "appointments-validate",
        component: () => import("@/views/appointments/Validate.vue"),
      },
    ],
  },
];
